import styled, { css } from 'styled-components';

import { CardConsts } from './Card.consts';
import { CardPaddingSizes } from './Card.types';

type CardBodyProps = {
  padding: CardPaddingSizes | undefined;
};

const paddingLeftRightValue = (padding: CardPaddingSizes): string => `${CardConsts.paddingLeftRight[padding]}px`;
const paddingTopBottomValue = (padding: CardPaddingSizes): string => `${CardConsts.paddingTopBottom[padding]}px`;

const Card = styled.div`
  ${({ theme }) => css`
    width: fit-content;
    border-radius: 2px;
    background-color: ${theme.background.surface};
    box-shadow: ${theme.elevation.level1};
  `}
`;

const CardBody = styled.div<CardBodyProps>`
  ${({ padding, theme }) => css`
    display: grid;
    ${theme.paragraph.medium.normal}

    ${padding &&
    css`
      padding: ${paddingTopBottomValue(padding)} ${paddingLeftRightValue(padding)};
    `}
  `}
`;

export { Card, CardBody };
